import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.others.bg1,
    paddingTop: theme.spacing.unit * 4 + 3,
    paddingBottom: theme.spacing.unit * 4 + 3,
    paddingLeft: theme.spacing.unit * 3 + 1,
    paddingRight: theme.spacing.unit * 3 + 1,
    textAlign: 'center',
    borderRadius: '0px',
  },
  subhead: {
    marginTop: '10px',
  },
  card: {
    backgroundColor: '#fff',
  },
  oddcard: {
    backgroundColor: theme.palette.others.bg1,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  imageContainer: {
    minWidth: '255px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    // float: 'left',
    paddingRight: theme.spacing.unit * 2 + 4,
    paddingLeft: theme.spacing.unit * 2 + 4,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
    // clear: 'both',
  },
  avatar: {
    margin: 3,
  },
  bigAvatar: {
    width: '100px',
    height: '100px',
    backgroundColor: '#d5d5d54a',
  },
  member_name: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: '#843384cf',
  },
  infoContent: {
    wordBreak: 'break-word',
  },
  careerCard: {
    marginTop: theme.spacing.unit * 2 + 4,
    marginRight: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
    marginLeft: theme.spacing.unit * 2 + 4,
  },
  paramode: {
    marginTop: theme.spacing.unit + 7,
  },
  joinusbtn: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing.unit,
  },
  titleContent: {
    paddingTop: '2%',
    backgroundColor: 'white',
    paddingLeft: theme.spacing.unit * 2 + 4,
  },
});

const data = [
  {
    name: 'Maheima Kapur',
    img: '/img/f1.png',
    title: 'Co-Founder',
    description: `Maheima believes that no travel adventure is truly great if you don't meet, mingle and eat food like the locals do. She delights in sharing her experiences through Talking Street and does so by writing for the platform. She is equally passionate about ensuring that this community of foodies come together to have a fantastic experience on Talking Street. It's a tough contest for what she loves more, travelling into the depths of nature, taking pictures or writing about food and adventures. If she were a dish, she'd be the Tamil (now, that is specific!) idli - soft, easy, versatile, and hugely comforting.`,
  },
  {
    name: 'Abhishek Mukherjee',
    img: '/img/f2.png',
    title: 'Co-Founder',
    description: `Abhishek strongly believes that food is a great entry to a culture and its people. At Talking Street he delights in making experiences come alive via the āhāra by Talking Street platform, apart from working closely on all aspects of the business & operations. His weekends are spent reading travelogues, catching up on current affairs from across the globe on BBC or The Economist, and playing with his two young boys. If he were a dish, he'd be a Biryani- the perfect combination of everything- rice, meat, spices, prepared over hours and served steaming hot.`,
  },
  {
    name: 'Smitha Lahiri',
    img: '/img/Smitha Lahiri.jpg',
    title: 'Product Strategist',
    description: `A food lover who believes food is meant to be an experience for all our senses, Smitha is a product strategist with a keen eye for market research and trends, competitors, customer needs and insights. When not working she is found going on roadtrips, taking photographs, blogging and writing terribly tiny tales. If she were a dish, she'd be a seafood bisque, a great balance of depth and flavours.`,
  },
  {
    name: 'Shadan Syed',
    img: '/img/Shadan-Syed-Talking-Street-Team.jpg',
    title: 'Social Media Lead',
    description: `Shadan always wanted to work with something she loved, so it was obvious that her obsession with food led her to be the social media manager of Talking Street. With various creative campaigns constantly up her sleeve, she connects with users intuitively to form lasting relationships that begin online. When not working, she is found dancing, eating or playing with her daughter. If she were a dish, she'd be a biryani - spicy, flavourful, and absolutely drool worthy.`,
  },

  {
    name: 'Sharath Kumar',
    img: '/img/f3.png',
    title: 'Tech lead',
    description: `Sharath truly believes that humans have a curious (offbeat?) relationship with food. While for some it's a necessity, for others it's a craving, or in the worst case, an allergy. For him? It's an obsession and now it has charmed it's way into his profession as well. At Talking Street, he leads tech, ensuring that the product in your hands is delightful at every level. His down-time includes traveling, binge-watching Netflix or partying with his friends. If he were a dish, he'd be a pickle, one that would go very well with anyone and everyone.`,
  },
  {
    name: 'Anit Kumar',
    img: '/img/0.jpeg',
    title: 'Jr. Full Stack Developer',
    description: `As a full stack developer at Talking Street, Anit is passionate about the challenges that come with developing an elegant and functional UI. When not working, he devotes his time to his true passion of learning new technologies and frameworks. He also works really hard at making sure he carves the time to travel with his friends and visit beaches across the country. If he were a dish, he'd be pani puri - sweet, tangy and fun, all at the same time. `,
  },
];

const data2 = [
  {
    name: 'Deepak',
    img: '/img/IMG-20190221-WA0009.jpg',
    title: 'Back-end Tech expert',
    description: `Deepak is always excited to work with food. He is a technical guru and is never shy to lend a hand with back-end issues. In his spare time, one can find him raiding enemy villages in video games or watching and playing football. He also enjoys cooking spicy(!), scrumptious meals for his friends at home. If he were a dish, he'd be a piece of warm chocolate cake with a scoop of vanilla ice cream, wicked and delicious.`,
  },
  {
    name: 'Priyanka',
    img: '/img/Priyanka_TalkingStreet-Resized.jpg',
    title: 'Content Writer',
    description: `For Priyanka, food is more than just ingredients. It's the people she eats with and the memories she makes that make it a wholesome meal. She is a content writer who thanks her lucky stars that she gets to write about food for a living. She also spends her time working with children's books. She loves going deep in the forest looking for big cats just as much as she enjoys cooking up a storm for her friends. If she were a dish, she'd be a jalebi, a little crunchy on the outside, gooey on the inside, and most importantly, delicious to boot.`,
  },
];

// const data3 = [
//   {
//     name: 'Naganand Doraswamy',
//     img: '/icons/user.png',
//     title: 'Mentor',
//     description: `Naganand Doraswamy is a serial entrepreneur turned investor. A former president of TiE Bangalore, he has 25+ years of experience in management and technology. As co-founder and EVP of SPAN, Naganand actively led engineering in R&D apart from providing strategic growth inputs across the business streams. Prior to SPAN, Naganand has had several successful stints across startups and established organizations in the USA. When he's not mentoring young companies, he is usually playing tennis or even the occasional golf. He shakes off the day by sitting back with a good work of fiction.`,
//   },
//   {
//     name: 'Zunder Lekshmanan',
//     img: '/img/f4.png',
//     title: 'Technical Advisor',
//     description: `Zunder Lekshmanan is a highly experienced computer professional with over 20 years of rich and extensive experience in the Internet and Telecom sector working in Software Product Development and Solution Delivery. He has to his credit products that have up to five nines availability in at least 50 leading telecom operators across the globe, and applications like browsers, protocol stack, messaging clients that run in millions of devices ranging from feature phones to smartphones from the top handset manufacturers. His current Interests include IOT, Wearables, Breaking Digital Divide and especially connecting the unconnected.`,
//   },
// ];

const MemberCards = ({ data, classes, index }) => {
  return (
    <div className={index % 2 ? classes.card : classes.oddcard}>
      <CardContent>
        <div className={classes.imageContainer}>
          <div className={classes.row}>
            <Avatar
              alt={data.name}
              src={data.img}
              className={classNames(classes.avatar, classes.bigAvatar)}
            />
          </div>
          <Typography
            className={classes.member_name}
            component="h6"
            variant="h6"
          >
            {data.name}
          </Typography>
          <Typography
            className={classes.member_name}
            color="textSecondary"
            component="h6"
            variant="body1"
          >
            {data.title}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            Contributions
          </Button>
        </div>
        <Typography
          className={classes.infoContent}
          component="h5"
          variant="body1"
        >
          {data.description}
        </Typography>
      </CardContent>
    </div>
  );
};

const SideMemberCards = ({ classes, index, data2 }) => {
  return (
    <div className={index % 2 ? classes.card : classes.oddcard}>
      <CardContent>
        <div className={classes.imageContainer}>
          <div className={classes.row}>
            <Avatar
              alt={data2.name}
              src={data2.img}
              className={classNames(classes.avatar, classes.bigAvatar)}
            />
          </div>
          <Typography
            className={classes.member_name}
            component="h6"
            variant="h6"
          >
            {data2.name}
          </Typography>
          <Typography
            className={classes.member_name}
            color="textSecondary"
            component="h6"
            variant="body1"
          >
            {data2.title}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            Contributions
          </Button>
        </div>
        <Typography
          className={classes.infoContent}
          component="h5"
          variant="body1"
        >
          {data2.description}
        </Typography>
      </CardContent>
    </div>
  );
};

class Team extends React.Component {
  render() {
    const { classes } = this.props;
    let members = [];
    if (data.length > 0) {
      data.map((content, index) => {
        return members.push(
          <MemberCards
            key={'content' + index}
            index={index + 1}
            data={content}
            classes={classes}
          />
        );
      });
    }

    let sideMembers = [];
    if (data2.length > 0) {
      data2.map((contents, index) => {
        return sideMembers.push(
          <SideMemberCards
            key={'side' + index}
            index={index + 1}
            data2={contents}
            classes={classes}
          />
        );
      });
    }
    return (
      <div>
        <Paper className={classes.root} elevation={1}>
          <Typography variant="h5" component="h5">
            Meet the team
          </Typography>
          <Typography
            className={classes.subhead}
            color="textSecondary"
            component="h6"
            variant="body1"
          >
            Talking Street is a gastronomical labour of love, built by many
            contributing artists.
          </Typography>
        </Paper>
        <div>
          <div className={classes.titleContent}>
            <Typography component="h5" variant="h5">
              The Food Fanatics
            </Typography>
          </div>
          <React.Fragment>{members}</React.Fragment>
          <br />
        </div>
        <div>
          {/* <div className={classes.titleContent}>
            <Typography component="h5" variant="h5">
              Side Accompaniments
            </Typography>
          </div> */}
          <React.Fragment>{sideMembers}</React.Fragment>
          <br />
        </div>
        <div>
          <div className={classes.titleContent}>
            <Typography component="h5" variant="h5">
              The Mentors
            </Typography>
          </div>
          <div className={classes.card}>
            <CardContent>
              <div className={classes.imageContainer}>
                <div className={classes.row}>
                  <Avatar
                    alt="Naganand"
                    src="/img/Naganand_1.jpg"
                    className={classNames(classes.avatar, classes.bigAvatar)}
                  />
                </div>
                <Typography
                  className={classes.member_name}
                  component="h6"
                  variant="h6"
                >
                  Naganand Doraswamy
                </Typography>
                <Typography
                  className={classes.member_name}
                  color="textSecondary"
                  component="h6"
                  variant="body1"
                >
                  Mentor
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                >
                  Contributions
                </Button>
              </div>
              <Typography
                className={classes.infoContent}
                component="h5"
                variant="body1"
              >
                Naganand Doraswamy is a serial entrepreneur turned investor. A
                former president of TiE Bangalore, he has 25+ years of
                experience in management and technology. As co-founder and EVP
                of SPAN, Naganand actively led engineering in R&D apart from
                providing strategic growth inputs across the business streams.
                Prior to SPAN, Naganand has had several successful stints across
                startups and established organizations in the USA. When he's not
                mentoring young companies, he is usually playing tennis or even
                the occasional golf. He shakes off the day by sitting back with
                a good work of fiction.
              </Typography>
            </CardContent>
          </div>
          <div className={classes.oddcard}>
            <CardContent>
              <div className={classes.imageContainer}>
                <div className={classes.row}>
                  <Avatar
                    alt="Zunder"
                    src="/img/f4.png"
                    className={classNames(classes.avatar, classes.bigAvatar)}
                  />
                </div>
                <Typography
                  className={classes.member_name}
                  component="h6"
                  variant="h6"
                >
                  Zunder Lekshmanan
                </Typography>
                <Typography
                  className={classes.member_name}
                  color="textSecondary"
                  component="h6"
                  variant="body1"
                >
                  Technical Advisor
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                >
                  Contributions
                </Button>
              </div>
              <Typography
                className={classes.infoContent}
                component="h5"
                variant="body1"
              >
                Zunder Lekshmanan is a highly experienced computer professional
                with over 20 years of rich and extensive experience in the
                Internet and Telecom sector working in Software Product
                Development and Solution Delivery. He has to his credit products
                that have up to five nines availability in at least 50 leading
                telecom operators across the globe, and applications like
                browsers, protocol stack, messaging clients that run in millions
                of devices ranging from feature phones to smartphones from the
                top handset manufacturers. His current Interests include IOT,
                Wearables, Breaking Digital Divide and especially connecting the
                unconnected.
              </Typography>
            </CardContent>
          </div>
        </div>
        <div className={classes.careerCard}>
          <Typography component="h5" variant="h5">
            Careers
          </Typography>
          <Typography
            className={classes.paramode}
            component="h6"
            variant="body1"
          >
            To explore working at Talking Street, write to us at
            apply@talkingstreet.in.
          </Typography>
          {/* <div className={classes.joinusbtn}>
            <Button variant="contained" color="secondary">
              Join us
            </Button>
          </div> */}
        </div>
      </div>
    );
  }
}

Team.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Team);
